import { apiV2, errorHandler } from "./index";
import {
  API_ERROR,
  FETCH_SEARCH_DEEPLINKS,
} from "../constants/ActionTypes";
import Swal from "sweetalert2";

export function fetchSearchDeeplinksInfo() {
  return function (dispatch) {
    apiV2.get('/app/general-info')
      .then(response => {
        const data = {
          deeplink_ios: response.data.search_deeplink_ios_url ?? "",
          deeplink_android: response.data.search_deeplink_android_url ?? "",
          deeplink_image_url: response.data.search_deeplink_image_url ?? "",
        };
        dispatch({
          type: FETCH_SEARCH_DEEPLINKS,
          payload: data
        });
      })
      .catch(error => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function saveSearchDeeplinksInfo(
  deeplink_image_url,
  deeplink_ios_url,
  deeplink_android_url
) {
  return async function (dispatch) {
    try {
      await apiV2.put('/general-info/search-deeplink-info', {
        search_deeplink_image_url: deeplink_image_url,
        search_deeplink_ios_url: deeplink_ios_url,
        search_deeplink_android_url: deeplink_android_url,
      });
      Swal.fire({
        icon: "success",
        title: "Deeplinks Saved!",
        timer: 1000
      });
    } catch (error) {
      errorHandler(dispatch, error.response, API_ERROR);
    }
  };
}
